import React, { useEffect, useState } from "react";
import ErrorMessage from "../../containers/ErrorMessage";
import { connection_platform } from "../../services/api";
import { Redirect } from "react-router";

//COMPONENTS
import { ReactComponent as LogoIcon } from "../../build/images/login/logo.svg";
import { ReactComponent as UserIcon } from "../../build/images/login/user.svg";
import { ReactComponent as EyeIcon } from "../../build/images/login/eye.svg";

import { useDispatch, useSelector } from "react-redux";

//STYLES
import "./loginV2.styles.css";
import {
  TestConnection,
  checkDomainV2,
  errorLogin,
  login,
} from "../../actions";
import md5 from "md5";
import { Link } from "react-router-dom";

var i = 1;

// Solicita a permissão para realizar as notificações
document.addEventListener("DOMContentLoaded", function () {
  if (Notification.permission !== "granted") Notification.requestPermission();
});
// Função para exibir as notificações
function NofiticacaoGoogleChrome() {
  if (!Notification) {
    alert(
      "Notificações de área de trabalho que não estão disponíveis no seu navegador. Tente com o navegador Google Chrome"
    );
    return;
  }

  if (Notification.permission !== "granted") Notification.requestPermission();
  else {
    var notification = new Notification("Notificação IngWeb", {
      icon: "https://cdn3.iconfinder.com/data/icons/ose/Warning.png",
      body: "Notificação Navegador",
    });

    notification.onclick = function () {
      window.open("http://site.com.br/pagina.html");
    };
  }
}

function spawnNotification(opcoes) {
  var n = new Notification(opcoes.title, opcoes.opt);
  if (opcoes.link !== "") {
    n.addEventListener("click", function () {
      n.close();
      window.focus();
      window.location.href = opcoes.link;
    });
  }
}

let campaignsFilters = localStorage.getItem("campaignsFilters")
    ? JSON.parse(localStorage.getItem("campaignsFilters"))
    : "";

function LoginV2() {
  //REDUX
  const dispatch = useDispatch();
  const informationusers = useSelector((state) => {
    return state.informationusers;
  });
  const reasonsblock = useSelector((state) => {
    return state.reasonsblock;
  });
  //STATES
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [error, setError] = useState({ isError: false, message: "" });
  const [loading, setLoading] = useState(false);

  //FUNCTIONS
  const handleUserNameChange = (event) => {
    setUserName(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError({ isError: false, message: "" });
    if (!loading) {
      const passwordMd5 = md5(password);
      const emailWithNoSpaces = userName.trim();
      const post = {
        email: emailWithNoSpaces,
        password: md5(password),
        setLoading,
      };
      if (connection_platform.isOrganization === true) {
        if (emailWithNoSpaces.trim()) {
          let domain = userName.lastIndexOf("@");
          if (domain !== -1) {
            dispatch(
              checkDomainV2(
                emailWithNoSpaces.substring(domain),
                emailWithNoSpaces,
                passwordMd5
              )
            );
          } else {
            dispatch(errorLogin(null, null, "ON1"));
          }
        }
      } else {
        dispatch(login(post));
      }
    }
  };

  const handleShowOrHidePassword = () => {
    const isVisible = !isPasswordVisible;
    setIsPasswordVisible(isVisible);
  };

  //USE EFFECTS
  useEffect(() => {
    dispatch(TestConnection());
    localStorage.setItem("info_login", "useroff");
  }, []);

  useEffect(() => {
    if (informationusers) {
      if (
        informationusers.error &&
        (informationusers.server === "ON1" ||
          informationusers.server === "ON2" ||
          informationusers.server === "OFF")
      ) {
        setError({ isError: true, message: "Usuário e/ou senha incorreta(s)" });
      }

      if (informationusers.error && informationusers.server === "ON") {
        setError({
          isError: true,
          message: "Ocorreu um erro, tente novamente mais tarde!",
        });
      }
    }
  }, [informationusers]);

  if (informationusers) {
    if (informationusers.force_password_change) {
      return <Redirect to="/changepassword" />;
    }
    if (
      informationusers.displayname != undefined &&
      informationusers.error === undefined &&
      informationusers.error != true &&
      reasonsblock != 0
    ) {
      if(campaignsFilters){
        campaignsFilters.dataInitial = new Date(new Date().setDate(new Date().getDate() - 30))
        campaignsFilters.dataFinal = new Date()

        window.localStorage.setItem(
          "campaignsFilters",
          JSON.stringify(campaignsFilters)
        );
      }

      if (!informationusers.force_password_change) {
        return <Redirect to="/dashboard" />;
      }
    }
  }

  return (
    <div className="login">
      <div className={connection_platform.class_image_login}></div>
      <div className="col-form login__col-form">
        <div className="block no-round login__col-form__formContainer">
          <div className="block-content login__col-form__content">
            <form
              onSubmit={handleSubmit}
              name="form_login"
              className="row justify-content-md-center"
              id="form_login"
              autoComplete="off"
            >
              <div className="form-group">
                <h2 className="form_login__welcomeText">Seja Bem-vindo!</h2>
              </div>
              <div className="form-group form-group__email">
                <label className="form_login__form-group__emailLabel">
                  Login (Entre com o seu usuário)
                </label>
                <div className="form-group__email__borderInput">
                  <input
                    required
                    autoFocus={true}
                    type="text"
                    name="email"
                    id="email"
                    placeholder="Usuário"
                    value={userName}
                    onChange={handleUserNameChange}
                    autoComplete="off"
                  />
                  <UserIcon />
                </div>
              </div>
              <div className="form-group form-group__password">
                <label className="form_login__form-group__passwordLabel">
                  Senha
                </label>
                <div className="form-group__password__borderInput">
                  <input
                    required
                    autoFocus={false}
                    value={password}
                    onChange={handlePasswordChange}
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="Senha"
                    autoComplete="off"
                  />
                  <div
                    className="form-group__password__eyeIcon"
                    onClick={handleShowOrHidePassword}
                  >
                    <EyeIcon />
                  </div>
                </div>
              </div>
              <div className="form-group form-group__btn">
                <button
                  type="submit"
                  className="form_login__form-group__submitButton"
                >
                  Entrar
                </button>
              </div>
              {error.isError && (
                <span className="formr-group__error">{error.message}</span>
              )}
            </form>
          </div>
        </div>
        <div className="login__col-form__logo">
          <div className="login__col-form__logo__container">
            <LogoIcon />
          </div>
        </div>
      </div>
      <ErrorMessage />
    </div>
  );
}

export default LoginV2;
